(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hdb016-waitlist"] && !Shopify.designMode) return;
  try {
    
(() => {
  function start() {
    const home = document.getElementById('wi-hdb016-form-home');
    const panel = document.getElementById('wi-hdb016-marketing-form');
    if (!home || !panel || home.dataset.initialized) return;
    home.dataset.initialized = 'true';
    const watched = new WeakSet();
    function prefill() {
      for (const embed of panel.querySelectorAll('shopify-forms-embed')) {
        const root = embed.shadowRoot;
        if (!root) continue;
        if (!watched.has(root)) {
          watched.add(root);
          new MutationObserver(prefill).observe(root, {childList:true, subtree:true});
        }
        const details = root.querySelector('textarea[name="custom#additional_details"]');
        if (details && !details.dataset.waitlistPrefilled) {
          details.dataset.waitlistPrefilled = 'true';
          if (!details.value) {
            Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value').set.call(details, 'please add me to the HDB016 waitlist.');
            details.dispatchEvent(new Event('input', {bubbles:true, composed:true}));
            details.dispatchEvent(new Event('change', {bubbles:true, composed:true}));
          }
        }
      }
    }
    function mount() {
      const slot = document.querySelector('[data-hdb016-form-slot]');
      if (slot && !slot.contains(panel)) {
        slot.replaceChildren(panel);
      } else if (!slot && !home.contains(panel)) {
        home.appendChild(panel);
      }
      prefill();
    }
    new MutationObserver(mount).observe(document.body, {childList:true, subtree:true});
    new MutationObserver(prefill).observe(panel, {childList:true, subtree:true});
    mount();
    let attempts = 0;
    const ready = setInterval(() => {
      prefill();
      if (++attempts >= 40 || panel.querySelector('shopify-forms-embed')?.shadowRoot?.querySelector('textarea[data-waitlist-prefilled]')) clearInterval(ready);
    }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watchit-star-wars"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=()=>{const root=document.querySelector('[data-wi-star-wars]');if(!root||root.dataset.ready)return;root.dataset.ready='true';let side='all';const status=root.querySelector('[data-wi-sw-status]');const labels={dark:root.querySelector('[data-wi-side="dark"] .wi-sw-tile-label').textContent,light:root.querySelector('[data-wi-side="light"] .wi-sw-tile-label').textContent,droids:root.querySelector('[data-wi-side="droids"] .wi-sw-tile-label').textContent};const match=(handle)=>side==='all'||(side==='dark'?/darth|death-star|imperial|stormtrooper/.test(handle):side==='light'?/jedi|yoda|luke|ahsoka|rebel|chewbacca|millennium|bespin|duel|trench-run/.test(handle):/r2-d2|c-3po/.test(handle));const apply=()=>{const grid=document.querySelector('#bls__product-grid');if(!grid)return;let count=0;grid.querySelectorAll('[data-item-type="product"]').forEach(item=>{const link=item.querySelector('a[href*="/products/"]');const handle=link?.getAttribute('href')?.split('/products/')[1]?.split(/[?#]/)[0]||'';const show=match(handle);item.classList.toggle('wi-sw-hidden',!show);if(show)count++;});root.querySelectorAll('[data-wi-side]').forEach(link=>link.setAttribute('aria-pressed',String(link.dataset.wiSide===side)));const reset=root.querySelector('.wi-sw-reset');reset.hidden=side==='all';const message=side==='all'?status.dataset.all:status.dataset.matches.replace('[count]',String(count)).replace('[side]',labels[side]);if(status.textContent!==message)status.textContent=message;};root.querySelectorAll('[data-wi-side]').forEach(link=>{link.setAttribute('role','button');link.addEventListener('click',()=>{side=link.dataset.wiSide;apply();});link.addEventListener('keydown',event=>{if(event.key===' '){event.preventDefault();link.click();}});});const observer=new MutationObserver(mutations=>{if(mutations.some(m=>m.type==='childList'))apply();});const main=document.querySelector('#MainContent');if(main)observer.observe(main,{childList:true,subtree:true});apply();};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init);})();

  } catch(e) { console.error(e); }
})();
})();
